type JoyStickProps = {
  runAnimation: boolean;
  count: number;
  type?: "bottom" | "info";
};

export default function JoyStick({ runAnimation, count, type }: JoyStickProps) {
  return (
    <>
      {runAnimation ? (
        count === 0 ? (
          <img
            src={`${type === "bottom" ? "/images/icons/joystick.svg" : "/images/icons/joystick-black.svg"}`}
          />
        ) : count === 1 ? (
          <img
            src={`${type === "bottom" ? "/images/icons/joystick-left.svg" : "/images/icons/joystick-left-black.svg"}`}
          />
        ) : count === 2 ? (
          <img
            src={`${type === "bottom" ? "/images/icons/joystick.svg" : "/images/icons/joystick-black.svg"}`}
          />
        ) : count === 3 ? (
          <img
            src={`${type === "bottom" ? "/images/icons/joystick-right.svg" : "/images/icons/joystick-right-black.svg"}`}
          />
        ) : count === 4 ? (
          <img
            src={`${type === "bottom" ? "/images/icons/joystick.svg" : "/images/icons/joystick-black.svg"}`}
          />
        ) : (
          <img
            src={`${type === "bottom" ? "/images/icons/joystick-left.svg" : "/images/icons/joystick-left-black.svg"}`}
          />
        )
      ) : (
        <img
          src={`${type === "bottom" ? "/images/icons/joystick.svg" : "/images/icons/joystick-black.svg"}`}
        />
      )}
    </>
  );
}
